import { render, staticRenderFns } from "./JobKanBan.vue?vue&type=template&id=476f7220&"
import script from "./JobKanBan.vue?vue&type=script&lang=js&"
export * from "./JobKanBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports